module.exports = __webpack_public_path__ + "img/biaoqian_dingwei.60f28a34.png";